module.exports = __webpack_public_path__ + "static/media/device-pin.24a075b5.png";